import tkStorage from 'vue-tk/dist/utils/tkVuexStorage'
import config from 'config'
import store from '../store'
tkStorage.init(store, config.vuexStorageKeys)
let storageStore = tkStorage.restoreStorage()
store.commit('initFromStorage', storageStore)




// WEBPACK FOOTER //
// ./src/init/vuexStorage.js